var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PublishedItem',{attrs:{"item":_vm.visualization},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('CenterFrame',{attrs:{"src":_vm.getUrl}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }